import { useQuery } from '@tanstack/react-query';
import type { OrgContextValue, Organisation, OrgRole } from '@/contexts/OrgContext';

interface UserOrgApiResponse {
  user: { id: string; name: string; email: string } | null;
  organisation: Organisation | null;
  userOrg: { role?: OrgRole } | null;
}

export function useUserOrg(orgId?: string) {
  return useQuery<OrgContextValue>({
    queryKey: ['userOrg', orgId],
    enabled: !!orgId,
    queryFn: async () => {
      if (!orgId) throw new Error('orgId is required');
      const res = await fetch(`/api/userOrg/${orgId}`);
      if (!res.ok) throw new Error('Failed to fetch org data');
      const data: UserOrgApiResponse = await res.json();
      return {
        organisation: data.organisation ?? null,
        user: data.user ?? null,
        orgRole: data.userOrg?.role ?? null,
      };
    },
  });
}
